module.exports = __webpack_public_path__ + "static/media/banner-img-general_low.f9920327.png";